import { Icon, InputText } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"
import { InputAndButton } from "components/List/ItemView/styled"

import { ComponentProps } from "."

const NameAndSlugRow = ({
  isEditMode,
  item,
  nameRef,
  onGenerateSlug,
  slugRef
}: Pick<
  ComponentProps,
  "isEditMode" | "item" | "nameRef" | "onGenerateSlug" | "slugRef"
>) => (
  <FieldRow $items={2}>
    {isEditMode ? (
      <>
        <InputText
          defaultValue={item?.name}
          inputId="name"
          label="Name"
          name="name"
          ref={nameRef}
          required
        />

        <InputAndButton>
          <InputText
            defaultValue={item?.slug ?? ""}
            inputId="slug"
            label="Slug"
            name="slug"
            ref={slugRef}
            required
          />

          <Button
            icon={<Icon group="fa6" name="FaRotateLeft" />}
            iconOnly
            label="Generate Slug"
            onClick={onGenerateSlug}
            outlined
            transparent
          />
        </InputAndButton>
      </>
    ) : (
      <>
        <FieldLabelAndValue>
          <FieldLabel>{"Name"}</FieldLabel>

          <FieldValue>{item?.name}</FieldValue>
        </FieldLabelAndValue>

        <FieldLabelAndValue>
          <FieldLabel>{"Slug"}</FieldLabel>

          <FieldValue>{item?.slug}</FieldValue>
        </FieldLabelAndValue>
      </>
    )}
  </FieldRow>
)

export default NameAndSlugRow
